const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Google Meets Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Meets', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/v3/google-meets/:subresource', null, {
    submitCode: {params: {subresource: 'code'}, method: 'POST', isArray: false},
	  uninstall: {params: {subresource: 'uninstall'}, method: 'POST', isArray: false},
    meetsPermissionLink: {params: {subresource: 'permission'}, method: 'GET', isArray: false},
	  existsWithUser: {params: {subresource: 'exists'}, method: 'GET', isArray: false},
  });

}]);